import Header from '../components/Header';
import Hero from '../components/Hero';
import Problem from '../components/Problem';
import Solution from '../components/Solution';
import WhoItsFor from '../components/WhoItsFor';
// import Portfolio from '../components/Portfolio';
import About from '../components/About';
import FAQ from '../components/FAQ';
import DecorativeDivider from '../components/DecorativeDivider';
import KidsVidsDivider from '../components/KidsVidsDivider';
import SimpleDivider from '../components/SimpleDivider';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import StructuredData from '../components/StructuredData';

export default function Home() {
  return (
    <>
      <SEO
        title="Kids Vids - A Narrative of Your Life"
        description="Transform your family footage into beautiful narrative films. Professional video editing service in Adelaide. We turn your camera roll into cinema - creating visual time capsules for milestones, gifts, and preserving precious family memories."
        path="/"
      />
      <StructuredData type="home" />
      <Header />
      <main>
        <Hero image="/abstract-background-4.jpg" />
        <DecorativeDivider />
        <Problem />
        <Solution />
        <KidsVidsDivider />
        <WhoItsFor />
        <KidsVidsDivider />
        {/* <Portfolio /> */}
        <About />
        <SimpleDivider />
        <FAQ />
        <KidsVidsDivider />
        <Contact />
        <SimpleDivider />
      </main>
      <Footer />
    </>
  );
}
